import { React, useState, useRef, useEffect } from "react";
import {
  FaPaperPlane,
  FaAngleUp,
  FaAngleDown,
  FaCheckDouble,
  FaCheck,
  FaXmark,
  FaCommentDots,
  FaWhatsapp,
  FaPhone,
  FaFacebookMessenger,
  FaPlus,
  FaPaperclip,
  FaRegPaperPlane,
} from "react-icons/fa6";
import { v4 } from "uuid";
import * as constants from "./constants.json";

const Chat = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatOptions, setChatOptions] = useState(false);
  const [fullHStretch, setFullHStretch] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [identifier, setIdentifier] = useState(localStorage.getItem("livechat_id"));
  const [isConnected, setIsConnected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null)
  const group = 2;
  const ws = useRef(null);  // Using useRef to keep track of the WebSocket instance
  const timeRegEx = /([0-9]+):([0-9]+)/g;
  const {
    initMessage,
    borderRadius,
    whatsAppConfig,
    facebookConfig,
    cellPhoneConfig,
    liveChatConfig,
    mainButtonTextColor,
    mainButtonBgColorPrimary,
    mainButtonBgColorSecondary,
    mainButtonBgColorTertiary,
  } = constants;

  useEffect(() => {
    if (chatOpen) {
      // Establish the WebSocket connection when the component mounts
      ws.current = new WebSocket('ws://54.229.147.107:3000');

      ws.current.onopen = () => {
        console.log('WebSocket connection opened');
        setIsConnected(true);
        let temp_id = identifier;

        if (!identifier) {
          const id = v4();
          setIdentifier(id);
          localStorage.setItem("livechat_id", id);
          temp_id = id;
        };

        const messagePL = {
          type: "identify",
          user: "Customer",
          to: group,
          role: "client",
          from: temp_id,
          time: new Date().toLocaleTimeString(),
          initMessage: initMessage,
          metadata: {
            path: window.location.pathname
          }
        };

        const sMessagePL = JSON.stringify(messagePL);

        ws.current.send(sMessagePL);
      };

      ws.current.onclose = () => {
        console.log('WebSocket connection closed');
        setIsConnected(false);
      };

      // Clean up WebSocket connection when the component unmounts
      return () => {
        if (ws.current) {
          ws.current.close();
        }
      };
    }
  }, [chatOpen]);

  if (ws?.current) {
    ws.current.onmessage = async (event) => {
      const receivedMessage = event.data;
      console.log('Message from server:', receivedMessage);

      const messagePL = await JSON.parse(receivedMessage);
      if (messagePL.type === "message" || messagePL.type === "image" || messagePL.type === "video" || messagePL.type === "document") {
        const extConvo = [...conversation, messagePL];
        setConversation(extConvo);
      }
    };
  }

  useEffect(() => { console.log('conversation', conversation) }, [conversation])

  const sendMessage = messageData => {
    if (ws.current && messageData) {
      const messagePL = {
        type: "message",
        text: messageData,
        time: new Date().toLocaleTimeString(),
        user: "Customer",
        from: identifier,
        to: group,
        role: "client",
        metadata: {
          path: window.location.pathname
        }
      };

      const sMessagePL = JSON.stringify(messagePL);

      ws.current.send(sMessagePL);
      const extConvo = [...conversation, messagePL];
      setConversation(extConvo);
      textboxRef.current.value = ''; // Clear input field
    }
  };

  const textboxRef = useRef();

  const ChatBubble = (params) => {
    const { incoming, time, user, text, type } = params;
    return (
      <div className={`${incoming ? 'self-start' : 'self-end '} w-4/5 p-3 flex flex-col my-1 hover:z-100 hover:mix-blend-multiply hover:text-opacity-100 mb-3`}>
        <div className={`flex w-full flex-row  ${incoming ? 'justify-start' : 'justify-end '} pt-1`}>
          <p className="text-left text-sm text-gray-700 pr-4">{incoming ? user : "You"}</p>
          <p className="text-right text-sm text-gray-700">{time}</p>
        </div>
        {
          type === "image" ? (
            <img alt={`${text} Sent from ${incoming ? user : "You"}`} className={`${incoming ? 'text-left' : 'text-right'}`} src={text}></img>
          ) : type === "video" ? (
            <video controls className={`${incoming ? 'text-left' : 'text-right'}`} src={text}></video>
          ) : type === "message" ? (
            <p className={`${incoming ? 'text-left' : 'text-right'}`}>{text}</p>
          ) : type === "document" ? (
            <a href={`${text}`} target='_blank' rel="noreferrer" className="bg-slate-400 text-white w-full h-full aspect-video flex items-center justify-center border border-slate-500 group">
              <div className="flex flex-col w-full h-full items-center justify-center bg-slate-400 group">
                <FaPaperclip className="text-white text-2xl" />
                <p className="text-white group-hover:underline-offset-1 group">Attachment</p>
              </div>
            </a>
          ) : (null)
        }
      </div>
    )
  };

  // const onFileChange = event => {
  //   setSelectedFile(event.target.files[0]);
  // };

  // const onFileUpload = () => {
  //   // Create an object of formData
  //   const formData = new FormData();

  //   // Update the formData object
  //   formData.append(
  //     "myFile",
  //     selectedFile,
  //     selectedFile.name
  //   );

  //   // Details of the uploaded file
  //   console.log(selectedFile);

  //   // Request made to the backend api
  //   // Send formData object
  //   // axios.post("api/uploadfile", formData);
  // };

  const aChannels = [
    {
      icon: (<FaCommentDots />),
      type: 'livechat',
      clickEvent: () => setChatOpen(!chatOpen),
      ...liveChatConfig
    },
    {
      icon: (<FaWhatsapp />),
      type: 'whatsapp',
      clickEvent: () => console.log('WhatsApp'),
      ...whatsAppConfig
    },
    {
      icon: (<FaPhone />),
      type: 'phone',
      clickEvent: () => console.log('Phone'),
      ...cellPhoneConfig
    },
    {
      icon: (<FaFacebookMessenger />),
      type: 'facebook',
      clickEvent: () => console.log('Facebook'),
      ...facebookConfig
    }
  ]

  if (chatOpen) {
    return (
      <div className={`md:w-96 md:${fullHStretch ? 'max-h-[80vh]' : 'max-h-[500px]'} max-md:w-full max-md:${fullHStretch ? 'max-h-[90vh]' : 'max-h-[66vh]'} min-h-[15vh] flex flex-col h-min rounded-${borderRadius} backdrop-blur-sm transition-transform ease-in-out duration-500 bg-stone-300 font-sans`}>
        <div className={`flex flex-row items-center justify-between py-4 px-2 opacity-80 rounded-t-${borderRadius} drop-shadow-md shadow-gray-400 bg-gray-400`}>
          <div className="flex flex-row items-center justify-start w-full">
            <img src="/px.jpg" alt="business profile" className="h-10 w-10 object-center rounded-full mx-2" />
            <p className="ml-2">
              R-E-D / PostX
            </p>
          </div>
          <div className="flex flex-row items-center justify-end w-full">
            <button className={`text-2xl mx-2 ${fullHStretch && 'rotate-180'} transition-transform ease-in-out duration-300`} onClick={() => { setFullHStretch(!fullHStretch) }}><FaAngleUp /></button>
            <button className="text-2xl mx-2" onClick={() => { setChatOpen(!chatOpen) }}><FaXmark /></button>
          </div>
        </div>
        <div className="flex flex-col overflow-y-scroll p-2 mix-blend-darken">
          {
            conversation.map((m, i) => {
              return (
                <ChatBubble
                  key={i}
                  incoming={m?.role !== "client"}
                  text={m?.text}
                  time={m?.time?.match(timeRegEx)[0]} //Regex only matches hour / mins
                  user={m?.user}
                  type={m?.type} />
              )
            })
          }
        </div>
        <div className={`flex flex-row items-end justify-end pb-4 opacity-90 bg-gray-400 border-t border-gray-400`}>
          <input
            className={`flex w-full min-h-12 h-12 text-black bg-white z-0 focus-visible:outline-none focus-visible:border-black focus-visible:border focus-visible:bg-white duration-500 transition-all ease-in-out px-4 py-3 font-serif font-light`}
            ref={textboxRef}
            placeholder="Write a message..."
          ></input>

          {/* <input type="file" onChange={(e) => onFileChange(e)} />
          <button onClick={(e) => onFileUpload(e)}>
            <FaPlus className="group-hover:text-blue-800 group-hover:scale-125 duration-300 ease-in-out" />
          </button> */}

          {/* <button
            className="h-12 w-12 flex items-center justify-center border-b border-black p-4 text-2xl duration-500 transition-all ease-in-out bg-white group z-50"
            onClick={() => { sendMessage(textboxRef?.current?.value) }}
          >
            <FaPlus className="group-hover:text-blue-800 group-hover:scale-125 duration-300 ease-in-out" />
          </button> */}
          <button
            className={`h-12 w-12 flex items-center justify-center p-4 text-2xl duration-500 transition-all ease-in-out bg-white group z-50`}
            onClick={() => { sendMessage(textboxRef?.current?.value) }}
          >
            <FaRegPaperPlane className={`duration-300 ease-in-out text-black group-hover:scale-125`} />
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex w-full h-min">
      {chatOptions ? (
        <div className={`md:w-96 md:${fullHStretch ? 'max-h-[80vh]' : 'max-h-[500px]'} max-md:w-full max-md:pr-4 max-md:${fullHStretch ? 'max-h-[90vh]' : 'max-h-[66vh]'} flex flex-col-reverse h-min rounded-${borderRadius} backdrop-blur-sm transition-transform ease-in-out duration-500 bg-stone-300 overflow-y-scroll justify-center`}>
          <div className={`h-12 w-w-full flex items-center justify-center bg-gradient-to-tr from-${mainButtonBgColorPrimary} via-${mainButtonBgColorSecondary} to-${mainButtonBgColorTertiary} duration-500 transition-all ease-in-out hover:scale-110 hover:bg-blue-500 group`}>
            <button className={`text-2xl text-${mainButtonTextColor} text-center group-hover:animate-[wiggle_1s_ease-in-out] items-center justify-center m-0`} onClick={() => { setChatOptions(!chatOptions) }}><p className="text-xl text-white m-0">Contact Us</p></button>
          </div>
          <div className={`flex flex-col-reverse h-full w-full px-4 my-2 rounded-t-${borderRadius}`}>
            {aChannels.map(c => {
              if (c.enabled === true) {
                if (c.type !== 'livechat') {
                  return (
                    <a href={c.type == 'phone' ? `tel:${c?.number}` : c?.url} target='_blank' rel="noreferrer" key={c?.text} className={`group text-3xl flex w-full h-full rounded-${borderRadius} border border-${c.colorBorder} hover:border-${c.colorBorder} items-center justify-between my-2 pr-4 bg-${c.bgColor} hover:bg-${c.bgColorOH}`} onClick={c.clickEvent}>
                      <div className={`group flex h-14 w-14 items-center justify-center group-hover:bg-${c.bgColorOH} rounded-${borderRadius} text-white`}>
                        {c.icon}
                      </div>
                      <p className={`flex group text-${c.colorText} group-hover:text-${c.colorTextHover} text-center text-xl m-0`}>{c.text}</p>
                    </a>
                  )
                }
                return (
                  <button key={c.text} className={`group text-3xl flex w-full h-full rounded-${borderRadius} border border-${c.colorBorder} hover:border-${c.colorBorder} items-center justify-between my-2 pr-4 bg-${c.bgColor} hover:bg-${c.bgColorOH}`} onClick={c.clickEvent}>
                    <div className={`group flex h-14 w-14 items-center justify-center group-hover:bg-${c.bgColorOH} rounded-${borderRadius} text-white`}>
                      {c.icon}
                    </div>
                    <p className={`flex group text-${c.colorText} group-hover:text-${c.colorTextHover} text-center text-xl m-0`}>{c.text}</p>
                  </button>
                )
              }
            })}
          </div>
        </div>
      ) : (
        <div className={`border h-12 w-36 flex items-center justify-center bg-gradient-to-tr from-${mainButtonBgColorPrimary} via-${mainButtonBgColorSecondary} to-${mainButtonBgColorTertiary} duration-500 transition-all ease-in-out hover:scale-110 hover:bg-blue-500 group rounded-t-${borderRadius}`}>
          <button className={`text-2xl text-${mainButtonTextColor} text-center group-hover:animate-[wiggle_1s_ease-in-out] m-0`} onClick={() => { setChatOptions(!chatOptions) }}><p className="text-xl text-white m-0">Contact Us</p></button>
        </div>
      )}
    </div>
  )
};

export default Chat;